module.exports = __webpack_public_path__ + "img/documents-slim.4457c85d.svg";